import FullWidthLayout from "@/layouts/FullWidthLayout";
import { KPageIndex } from "kinnect-general";
import { Pageable } from "kinnect-mixins";

export default {
	name: "WarehousePage",

	metaInfo: { title: "Warehouse" },

	mixins: [ Pageable ],

	data: () => ( {
		items: [
			{
				title: "Carriers",
				to: { name: "carriers" }
			},
			{
				title: "Outbound Freight",
				to: { name: "outboundFreightList" }
			}
		]
	} ),

	render() {
		return <FullWidthLayout>
			<KPageIndex items={this.items}></KPageIndex>
		</FullWidthLayout>;
	}
};
